import styled from 'styled-components';
import theme from 'styles/theme';

export const Description = styled.p`
  color: ${theme.colors.secondaryText};
  line-height: ${theme.typography.lineHeight.medium};
  font-size: ${theme.typography.fontSize.formDesc};
`;

export const Title = styled.h1`
  font-size: 20px;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: ${theme.typography.lineHeight.large};
`;

export const Icon = styled.img``;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  gap: 20px;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 30px;
`;
